import { OrganizationKeyName } from "../../../model/Organization";
import { TimeslotTemplateListItem } from "../model/TimeslotTemplatesSuccessResponse";

export const GET_SHOP_TIMESLOTS = "SHOP:GET_SHOP_TIMESLOTS";

export const getShopTimeslotsAction = (
  organization: OrganizationKeyName,
  id: string
) => ({
  type: GET_SHOP_TIMESLOTS as typeof GET_SHOP_TIMESLOTS,
  id,
  organization,
});

export type GetShopTimeslotsAction = ReturnType<typeof getShopTimeslotsAction>;

export const GET_SHOP_TIMESLOTS_SUCCESS = "SHOP:GET_SHOP_TIMESLOTS_SUCCESS";

export const getShopTimeslotsSuccessAction = (
  organization: OrganizationKeyName,
  id: string,
  timeslots: TimeslotTemplateListItem[]
) => ({
  type: GET_SHOP_TIMESLOTS_SUCCESS as typeof GET_SHOP_TIMESLOTS_SUCCESS,
  id,
  organization,
  timeslots,
});

export type GetShopTimeslotsSuccessAction = ReturnType<
  typeof getShopTimeslotsSuccessAction
>;

export const GET_SHOP_TIMESLOTS_UPDATE_SUCCESS =
  "SHOP:GET_SHOP_TIMESLOTS_UPDATE_SUCCESS";

export const getShopTimeslotUpdateSuccessAction = (
  organization: OrganizationKeyName,
  shopId: string,
  id: string,
  timeslots: TimeslotTemplateListItem[]
) => ({
  type: GET_SHOP_TIMESLOTS_UPDATE_SUCCESS as typeof GET_SHOP_TIMESLOTS_UPDATE_SUCCESS,
  shopId,
  id,
  organization,
  timeslots,
});

export type GetShopTimeslotUpdateSuccessAction = ReturnType<
  typeof getShopTimeslotUpdateSuccessAction
>;
